import React from "react";
import LazyPageLoader from "../../components/cmp/LazyPageLoader";

const Page = React.lazy(() => import("./LearningIndex"));

export default function LazyLearningIndex(props) {
  return (
    <React.Suspense fallback={<LazyPageLoader />}>
      <Page {...props} />
    </React.Suspense>
  );
}
